import React from "react";
import ActionContext from "components/actionContext";

const actionContext = ({ isSubmitting, errors, text, onClick, variant }) => (
  <ActionContext
    disabled={isSubmitting || Object.keys(errors).length > 0}
    text={text}
    onClick={onClick}
    variant={variant}
  />
);

export default actionContext;
